import React, { useEffect, useRef } from 'react';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import InputValidator from './InputValidator';

const IntegerAnswer = (props) => {
    const divRef = useRef(null);
    const q = props.question;
    const id = q.questionID;

    useEffect(() => {
        if (divRef.current) {
            const label = divRef.current.querySelector('label');
            const input = divRef.current.querySelector('input');
            if (label && !label.getAttribute('id')) {
                label.setAttribute('id', q.question.alias || `q-${id}`);
            }
            if (input && !input?.getAttribute('aria-labelledby')) {
                input.setAttribute('aria-labelledby', q.question.alias || `q-${id}`);
            }
        }
    });

    const ret = [
        <TextField
            key={`qi${id}`}
            // type="number"
            error={props.error}
            disabled={props.disabled}
            name={`a${id}`}
            helperText={props.helperText}
            onChange={(e) => {
                props.responseHandler(id, InputValidator.allowChars(e.target.value, /\d/), e);
                props.validateField();
            }}
            value={q.response.responseText || ''}
        />
    ];
    if (q.answerSuffix) ret.push(<p key={`as${id}`}>{q.answerSuffix}</p>);
    return (
        <div ref={divRef}>
            <InputLabel className="questionnaire-body">
                <p>{q.question}</p>
                {ret}
            </InputLabel>
        </div>
    );
};

export default IntegerAnswer;
